module.exports = __webpack_public_path__ + "img/x15.3eed1e23.jpg";